// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2ptnF","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__i701d"};